import React from 'react';
import { Link } from 'react-router-dom';
import Masonry from 'react-masonry-css';

export default function Portfolio({ data }) {
  const breakpointColumnsObj = {
    default: 2,
    991: 1,
  };

  return (
    <section>
      <div className="container">
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {data?.map((item, index) => (
            <div key={index} className="masonry-item">
              <div className="cs_portfolio cs_style_1">
                <div className="cs_portfolio_thumb cs_radius_15">
                  <img src={item.imgUrl} alt="Portfolio" />
                </div>
                <div className="cs_portfolio_info">
                  <div className="cs_portfolio_info_in">
                    <h2 className="cs_portfolio_title cs_fs_38">
                      {item.title}
                    </h2>
                    <Link to={item.href} className="cs_portfolio_btn">
                      {item.btnText}
                    </Link>
                  </div>
                </div>
                <Link to={item.href} className="cs_portfolio_overlay" />
              </div>
            </div>
          ))}
        </Masonry>
      </div>
    </section>
  );
}
